import { startCase } from 'lodash';
import {
  formatCurrencyOnBlur,
  aggregateProjects,
} from '../../../helpers/utils';

export const getClientSummaryExcelData = (clients: any[]) => {
  const { hours, projects, ...statuses } = aggregateProjects(clients);

  const clientNames = [...new Set(clients.map(({ name }) => name))].join('; ');

  const aggregateSheet = [
    ['Aggregates'],
    ['Clients', clientNames],
    ['Total Projects', projects.count],
    [
      'Total Amount',
      projects.amount !== 0
        ? formatCurrencyOnBlur(projects.amount.toString())
        : 'No Recorded Info',
    ],
    ['Total Hours', hours.toFixed(2)],
  ];

  const statusRows = Object.entries(
    statuses as Record<string, { count: any; amount: any }>,
  ).map(([status, values]) => [
    startCase(status),
    values.count,
    values.amount !== 0 ? formatCurrencyOnBlur(values.amount.toString()) : '-',
  ]);

  const statusSheet = [['Status', 'Count', 'Amount'], ...statusRows];

  const projectRows = clients.map((p) => {
    let amount = p.amount_requested;
    if (p.status === 'Awarded') {
      amount = p.amount_awarded;
    }
    let projectHours = p.actual_hours;
    if (p.actual_hours >= 1 || p.actual_hours != null) {
      projectHours = p.actual_hours;
    } else {
      projectHours = p.estimated_hours;
    }
    return [
      p.name || '',
      p.funder_name || '-',
      p.description || '',
      formatCurrencyOnBlur(amount),
      p.status || '',
      p.deadline || '',
      projectHours || '',
    ];
  });

  const projectSheet = [
    ['Client', 'Funder', 'Project', 'Amount', 'Status', 'Due Date', 'Hours'],
    ...projectRows,
  ];

  return [
    { name: 'Aggregates', data: aggregateSheet },
    { name: 'Status Breakdown', data: statusSheet },
    { name: 'Projects', data: projectSheet },
  ];
};
